export default __webpack_public_path__ + "static/media/IMG_20211031_155241.c5cc1537.jpg";